import {
  Api,
  baseDataResponse,
  cruiseListRequest,
  cruiseListResponse,
} from './client';
import { fetch, CRUISESEARCH_API } from '../lib';

function getApi(fetchOpts: RequestInit) {
  return new Api({
    baseUrl: CRUISESEARCH_API,
    fetch,
    ...fetchOpts,
  });
}

type FetchOpts = Pick<RequestInit, 'signal'>;

export type BaseDataResponse = baseDataResponse;
export function getBaseData({ signal }: FetchOpts): Promise<BaseDataResponse> {
  return getApi({ signal }).getBaseData();
}

export type serviceTrips_inner = {
  journeyIdentifier: string;
  name: string;
  nights: number | string;
  ibeBlocked?: boolean;
};
export type serviceTrips = serviceTrips_inner[];

export type CruiseListRequest = Omit<cruiseListRequest, 'sort' | 'composition'>;
export type CruiseListResponse = cruiseListResponse;
export function postCruiseList(
  request: CruiseListRequest,
  { signal }: FetchOpts,
): Promise<CruiseListResponse> {
  return getApi({ signal }).postCruiseList(request);
}
